import { render } from "./cardForm.vue?vue&type=template&id=3fe54876&scoped=true"
import script from "./cardForm.vue?vue&type=script&lang=js"
export * from "./cardForm.vue?vue&type=script&lang=js"

import "./cardForm.vue?vue&type=style&index=0&id=3fe54876&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe54876"]])

export default __exports__